import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import Pagination from '@/components/ui/pagination/Pagination';
import ListItem from '@/components/ui/listItem/ListItem';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { GENRES_FOR_PAGE } from '@/helpers/variables';
import { IGenresAll } from '@/interfaces/genres.interface';

import { getCurrentPageName } from '@/helpers/helpers';

import styles from './Genres.module.scss';

interface IGenresAllProps {
  genres: IGenresAll;
}

const Genres: FC<IGenresAllProps> = ({ genres }) => {
  const pagesCount = Math.ceil(genres.total_count / GENRES_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `Список жанров литературы :: Электронная библиотека : скачать бесплатно книги - анекдоты про, фантастика, фэнтези, детективы, стихи о любви...${getCurrentPageName(genres.page)}`;
  const SEO_DESCRIPTION = 'Детективы, фантастика, фэнтези, женские романы, классика, компьютерная литература, история, приключения';
  const SEO_CANONICAL = '/genres';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} breadcrumbs={<Breadcrumbs firstPageName="Жанры" />}>
      <SectionTitle name="Жанры литературы" />
      <ul className={styles.genresList}>{genres.data.length > 0 ? genres.data.map((genre, index) => <ListItem key={genre.id} itemAlias={genre.alias} title={genre.title} count={genre.book_count} alias="genres" />) : 'Жанры не найдены'}</ul>
      <Pagination pagesCount={pagesCount ?? 0} postName="genres/page=" />
    </Layout>
  );
};

export default Genres;
